// Configuration des thèmes de l'application
import { imagesWmb, imagesTropical, imagesStandupCh, imagesSport } from '../mock/musicLabelsData';
import { imagesCultureFr } from '../mock/musicLabelsData';
import { imagesspkombat } from '../mock/musicLabelsData';

export const THEMES = {
  ROCK: 'rock',
  LATINO: 'latino',
  STANDUP_CH: 'standup',
  CULTURE_FR: 'culture_fr',
  spkombat: 'spkombat',
  fabiomeyer: 'fabiomeyer',
  jemmyx: 'jemmyx',
  SPORT: 'sport',
  WILDPEAKS: 'wildpeaks'
};

export const THEME_CONFIG = {
  [THEMES.spkombat]: {
    id: 'spkombat',
    name: 'spkombat',
    description: 'Vidéos et contenus de la chaîne spkombat',
    primary_color: '#222222',
    secondary_color: '#f2c300',
    accent_color: '#e94e77',
    labels: imagesspkombat,
    branding: {
      logo: '/images/logo-spkombat.png',
      favicon: '/favicon-spkombat.ico',
      social_image: '/images/logo-spkombat.png'
    },
    seo: {
      title: 'spkombat – Vidéos et Contenus Officiels',
      description: 'Retrouvez toutes les vidéos et contenus officiels de la chaîne spkombat.',
      keywords: 'spkombat, vidéos, officiel, gaming, culture, france'
    }
  },
  [THEMES.CULTURE_FR]: {
    id: 'culture_fr',
    name: 'Culture Française',
    description: 'Vidéos et contenus culturels français',
    primary_color: '#2e3192',
    secondary_color: '#f7f7f7',
    accent_color: '#e94e77',
    labels: imagesCultureFr,
    branding: {
      logo: '/images/logo-culturefr.png',
      favicon: '/favicon-culturefr.ico',
      social_image: '/images/culturefr-socialmedia.png'
    },
    seo: {
      title: 'Culture Française – Vidéos et Contenus Culturels',
      description: 'Découvrez le meilleur de la culture française : vidéos, documentaires, émissions, et plus encore.',
      keywords: 'culture française, vidéos, documentaires, émissions, art, patrimoine'
    }
  },
  [THEMES.ROCK]: {
    id: 'rock',
    name: 'Rock & Metal',
    description: 'Unleash the sound of chaos - Metal & Extreme music',
    primary_color: '#ff0000',
    secondary_color: '#000000',
    accent_color: '#ffffff',
    labels: imagesWmb,
    branding: {
      logo: '/images/logo-ragescream.png',
      favicon: '/favicon-rock.ico',
      social_image: '/images/ragescream.com-socialmedia.png'
    },
    seo: {
      title: 'RageScream – The Ultimate Metal & Extreme Music Experience',
      description: 'Unleash the sound of chaos with RageScream.com – your destination for pure Metal and Extreme music videos, 24/7. No compromise. Just Metal.',
      keywords: 'metal, extreme music, heavy metal, death metal, black metal, thrash metal'
    }
  },
  [THEMES.LATINO]: {
    id: 'latino',
    name: 'Latino Music',
    description: 'The best of Latin music - Reggaeton, Salsa, and more',
    primary_color: '#ff6b35',
    secondary_color: '#1a1a1a',
    accent_color: '#ffd700',
    labels: imagesTropical,
    branding: {
      logo: '/images/logo-tropicaliente.png',
      favicon: '/favicon-latino.ico',
      social_image: '/images/latino-socialmedia.png'
    },
    seo: {
      title: 'Latino Music Hub – The Ultimate Latin Music Experience',
      description: 'Discover the best of Latin music - Reggaeton, Salsa, Bachata, and more. Your destination for the hottest Latino artists and hits.',
      keywords: 'reggaeton, latin music, salsa, bachata, latino artists, spanish music'
    }
  },
  [THEMES.STANDUP_CH]: {
    id: 'standup',
    name: 'Stand-Up Comedy CH',
    description: 'Swiss and French comedy - Stand-up, sketches, and humor',
    primary_color: '#e74c3c',
    secondary_color: '#2c3e50',
    accent_color: '#f39c12',
    labels: imagesStandupCh,
    branding: {
      logo: '/images/logo-standupcomedy.png',
      favicon: '/favicon-standup.ico',
      social_image: '/images/standup-ch-socialmedia.png'
    },
    seo: {
      title: 'Stand-Up Comedy CH – Swiss & French Humor Hub',
      description: 'Discover the best of Swiss and French comedy - Stand-up shows, sketches, and the funniest comedians from Switzerland and France.',
      keywords: 'stand-up comedy, swiss humor, french comedy, humoristes, spectacles, comédie'
    }
  },
  [THEMES.fabiomeyer]: {
    id: 'fabiomeyer',
    name: 'Fabio Meyer',
    description: 'Exclusive content from Fabio Meyer',
    primary_color: '#123456',
    secondary_color: '#654321',
    accent_color: '#abcdef',
    labels: [], // Add appropriate labels if available
    branding: {
      logo: '/images/logo-fabiomeyer.png',
      favicon: '/favicon-fabiomeyer.ico',
      social_image: '/images/fabiomeyer-socialmedia.png'
    },
    seo: {
      title: 'Fabio Meyer – Exclusive Content',
      description: 'Discover exclusive content from Fabio Meyer, including videos, interviews, and more.',
      keywords: 'Fabio Meyer, exclusive content, videos, interviews'
    }
  },
  [THEMES.jemmyx]: {
    id: 'jemmyx',
    name: 'Jemmyx',
    description: 'Contenus exclusifs de Jemmyx',
    primary_color: '#123456',
    secondary_color: '#654321',
    accent_color: '#abcdef',
    labels: [],
    branding: {
      logo: '/images/logo-fabiomeyer.png',
      favicon: '/favicon-jemmyx.ico',
      social_image: '/images/fabiomeyer-socialmedia.png'
    },
    seo: {
      title: 'Jemmyx – Contenus Exclusifs',
      description: 'Découvrez des contenus exclusifs de Jemmyx, y compris des vidéos, des interviews, et plus encore.',
      keywords: 'Jemmyx, contenus exclusifs, vidéos, interviews'
    }
  },
  [THEMES.SPORT]: {
    id: 'sport',
    name: 'Sport',
    description: 'Vidéos et contenus sportifs exclusifs',
    primary_color: '#008000',
    secondary_color: '#ffffff',
    accent_color: '#0000ff',
    labels: imagesSport,
    branding: {
      logo: '/images/logo-sport.png',
      favicon: '/favicon-sport.ico',
      social_image: '/images/logo-sport.png'
    },
    seo: {
      title: 'Sport – Vidéos et Contenus Sportifs',
      description: 'Découvrez les meilleurs contenus sportifs : matchs, interviews, documentaires, et plus encore.',
      keywords: 'sport, vidéos, matchs, interviews, documentaires'
    }
  },
  [THEMES.WILDPEAKS]: {
    id: 'wildpeaks',
    name: 'Wild Peaks',
    description: 'Explore the wild and untamed landscapes.',
    primary_color: '#4CAF50',
    secondary_color: '#8BC34A',
    accent_color: '#CDDC39',
    labels: imagesSport,
    branding: {
      logo: '/images/logo-wildpeaks.png',
      favicon: '/favicon-wildpeaks.ico',
      social_image: '/images/wildpeaks-socialmedia.png'
    },
    seo: {
      title: 'Wild Peaks – Discover the Untamed',
      description: 'Immerse yourself in the beauty of wild landscapes and untamed nature.',
      keywords: 'wild, nature, landscapes, adventure'
    }
  }
};

// Fonction pour obtenir le thème par défaut
export const getDefaultTheme = () => {
  // Défaut vers rock/metal
  return THEMES.ROCK;
};

// Fonction pour obtenir la configuration d'un thème
export const getThemeConfig = (themeId) => {
  // console.log(`Fetching theme config for: ${themeId}`);
  return THEME_CONFIG[themeId] || THEME_CONFIG[getDefaultTheme()];
};

// Fonction pour obtenir tous les thèmes disponibles
export const getAvailableThemes = () => {
  return Object.values(THEMES);
};

// Fonction pour valider si un thème existe
export const isValidTheme = (themeId) => {
  return Object.values(THEMES).includes(themeId);
};

export default {
  THEMES,
  THEME_CONFIG,
  getDefaultTheme,
  getThemeConfig,
  getAvailableThemes,
  isValidTheme
};
